import { useState, useEffect } from "react";

const IMAGES = [
  { src: "/api/uploads/hockey_girls_trio_group_v2.webp", alt: "Untamed Gear hockey team trio pose", tagline: "Bold Kits. Bolder Players." },
  { src: "/api/uploads/hockey_girls_sunset_by_goal.webp", alt: "Untamed Gear hockey sunset by goal", tagline: "Own The Astro." },
  { src: "/api/uploads/hockey_field_pink_stick.webp", alt: "Untamed Gear hockey field action with pink stick", tagline: "Kit Up. Bring The Fire." },
  { src: "/api/uploads/hockey_girls_bent_playing.webp", alt: "Untamed Gear hockey girls in action", tagline: "Made For The Match." },
  { src: "/api/uploads/hockey_kit_trio_group.webp", alt: "Untamed Gear hockey trio in matching kits", tagline: "Design That Moves With You." },
];

export default function HockeyHeroBanner() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % IMAGES.length), 4500);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="hockey-hero-banner"
      className="relative w-full aspect-[16/6] sm:aspect-[16/5] mb-8 overflow-hidden bg-[#0A0A0A] border border-[#262626]"
    >
      {IMAGES.map((img, i) => (
        <img
          key={img.src}
          src={img.src}
          alt={img.alt}
          loading={i === 0 ? "eager" : "lazy"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
      <div className="relative z-10 h-full flex flex-col justify-end sm:justify-center p-5 sm:p-10 max-w-2xl">
        <p className="text-[#F7931E] text-xs sm:text-sm font-bold uppercase tracking-[0.3em] mb-2 font-heading">
          Hockey Gear
        </p>
        <h2
          key={idx}
          data-testid="hockey-hero-tagline"
          className="text-white text-2xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] font-heading animate-fade-in"
        >
          {IMAGES[idx].tagline}
        </h2>
      </div>
      {/* Dots */}
      <div className="absolute bottom-3 right-4 flex gap-2 z-20">
        {IMAGES.map((img, i) => (
          <button
            key={img.src}
            onClick={() => setIdx(i)}
            aria-label={`Show slide ${i + 1}`}
            data-testid={`hockey-hero-dot-${i}`}
            className={`h-1.5 rounded-full transition-all ${
              i === idx ? "w-6 bg-[#F7931E]" : "w-1.5 bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
